module.exports = __webpack_public_path__ + "img/icon-editar-exibir.50d12c56.svg";